var n = /* @__PURE__ */ ((e) => (e.All = "all", e.Read = "read", e.Unseen = "unseen", e.Unread = "unread", e))(n || {});
export {
  n as FilterStatus
};
//# sourceMappingURL=constants.mjs.map
